import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, NavigationStart } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { BodyService } from '@sc-ui';
import { Location } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'skillconomy';

  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private bodyService: BodyService,
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: string) { }

  ngOnInit(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.route))
      .pipe(map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }))
      .pipe(filter(route => route.outlet === 'primary'))
      .pipe(mergeMap(route => route.data))
      .subscribe(event => this.handleRouteData(event));


    this.location.subscribe((ev: any) => {
      console.log(ev);
      this.lastPoppedUrl = ev.url;
    });



    this.router.events.subscribe((ev: any) => {

      if (isPlatformServer(this.platformId)) return;
      
      if (ev instanceof NavigationStart) {
        if (ev.url != this.lastPoppedUrl)
          this.yScrollStack.push(window.scrollY);
      } else if (ev instanceof NavigationEnd) {
        if (ev.url == this.lastPoppedUrl) {
          this.lastPoppedUrl = undefined;
          var scrollY = this.yScrollStack.pop();
          setTimeout(() => window.scrollTo(0, scrollY), 500);
        } else
          window.scrollTo(0, 0);
      }
    });
  }

  handleRouteData(data: any) {
    if (!data) return;
    var title = data.title ? this.title + ' - ' + data.title : this.title;
    this.titleService.setTitle(title);

    if (!data.bodyClasses) {
      this.bodyService.clearClasses();
      return;
    }

    data.bodyClasses.forEach(c => this.bodyService.addClass(c));
  }
}
